class receiveTicketModal {
    constructor($scope, $uibModalInstance, items1, httpRequest, composeService, logger, globalFn) {
        $scope.dictData = items1.dictData
        const getParamlist = (x) => {
            let paramList = x.map((el) => {
                const { orgId, orgName, taxCode, ukeyCode, ukeyId, diskId, diskType, applyRecordId } = el
                return { orgId, orgName, taxCode, ukeyCode, ukeyId, diskId, diskType, applyRecordId }
            })
            return paramList
        }
        const getReceiveInvInfo = (x) => {
            httpRequest.post_invoiceApplyNumByTaxCode(x).then((res) => {
                $scope.modalDetailsList = res.data.value
            })
        }
        const initComposeService = composeService(getReceiveInvInfo, getParamlist)
        initComposeService(items1.list)
        // 只能输入 0 正整数
        $scope.numCheck = (obj, attr) => {
            obj[attr] = obj[attr].replace(/\D/g, '')
            obj[attr] = obj[attr].replace(/^0+(?=\d)/, '')
            obj[attr] = obj[attr].replace(/\D/g, '')
            obj[attr] = obj[attr].replace(/^0+(?=\d)/, '')
        }
        const getOnlyCode = (list) => {
            // 数组去重
            const maps = new Map()
            let taxNoList = list.filter((el) => !maps.has(el.taxCode) && maps.set(el.taxCode, 1)).map((el) => el.taxCode)
            return { list, taxNoList }
        }
        const listDataPacket = (obj) => {
            const { list, taxNoList } = obj
            let dataPacket = []
            taxNoList.forEach((taxCode, index) => {
                let someCodeData = []
                list.forEach((el) => {
                    if (Object.is(el.taxCode, taxCode)) {
                        someCodeData.push(el)
                    }
                })
                dataPacket[index] = someCodeData
            })
            return dataPacket
        }
        const receiveInvNumCheck = (dataPacketList) => {
            for (let i = 0; i < dataPacketList.length; i++) {
                let buyNunTatal = 0
                let receiveNumTotal = 0
                let childItem = ''
                for (let j = 0; j < dataPacketList[i].length; j++) {
                    childItem = dataPacketList[i][j]
                    buyNunTatal = globalFn.Add(buyNunTatal, childItem.buyNumber * 1)
                    receiveNumTotal = globalFn.Add(receiveNumTotal, childItem.receiveInvNumber * 1)
                }
                if (receiveNumTotal > buyNunTatal) {
                    logger.logError(`${childItem.orgName}领票数量大于购票数量，请检查！`)
                    return false
                }
                continue
            }
            return true
        }
        const isAllEmpty = (x) => {
            if (!x) return false
            let isHasReceiveNumList = $scope.modalDetailsList.filter((el) => {
                if (el.receiveInvNumber) {
                    return true
                }
            })
            if (!isHasReceiveNumList.length) {
                logger.logError('请填写领购数量')
                return false
            }
            return true
        }
        const listDataComposeService = composeService(isAllEmpty, receiveInvNumCheck, listDataPacket, getOnlyCode)
        function paramHandel(list) {
            let paramList = list
                .filter((el) => {
                    if (el.receiveInvNumber) {
                        return true
                    }
                })
                .map((el) => {
                    const { diskType, diskId, taxCode, receiveInvNumber, applyRecordId } = el
                    return {
                        diskId,
                        diskType,
                        applyRecordId,
                        invoiceSourceQuery: {
                            taxNo: taxCode,
                        },
                        receiveInvNumber,
                        taxNo: taxCode,
                    }
                })
            return paramList
        }
        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function ok() {
            if (!listDataComposeService($scope.modalDetailsList)) return
            // 返回数据
            $uibModalInstance.close(paramHandel($scope.modalDetailsList))
        }
    }
}

receiveTicketModal.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'composeService', 'logger', 'globalFn']
export default receiveTicketModal



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/InventoryQuery/receiveTicketModal.js